import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"

export const PatientDetailStyles = makeStyles((theme: Theme) => ({
  patientDetailWrapper: {
    padding: "22px 21px 19px 47px",
  },
  headerSection: {
    marginBottom: "10px",
  },
  back: {},
  backImage: {},
  patientHeaderName: {
    fontSize: "28px !important",
    fontFamily: "Inter !important",
    letterSpacing: "2.25px !important",
    fontWeight: "bold !important",
    lineHeight: "41px !important",
  },
  patientId: {
    paddingLeft: "37px !important",
    color: "#9E9E9E !important",
    fontSize: "22px !important",
    lineHeight: "35px !important",
    letterSpacing: "1.95px !important",
    fontFamily: "Inter !important",
  },
  patientName: {
    fontFamily: "Inter !important",
    fontWeight: "bold !important",
    color: "#0126FF !important",
    fontSize: "25px !important",
  },
  phone: {},
  phoneIcon: {
    width: "24px !important",
    height: "24px !important",
  },
  phoneText: {
    paddingLeft: "10px",
  },
  email: {},
  emailIcon: {
    width: "24px !important",
    height: "24px !important",
  },
  emailText: {
    paddingLeft: "10px",
  },
  card: {
    padding: "0px 20px 21px 21px",
    borderRadius: "10px",
    border: "1px solid rgba(112, 112, 112, 0.4)",
    backgroundColor: "rgba(237, 238, 244, 1)",
  },
  pt21: {
    paddingTop: "21px",
  },
  rightCardSection: {},
  profilePic: {
    width: "241px",
    height: "232px",
  },
  profilePicImage: {
    width: "241px",
    height: "232px",
    objectFit: "cover",
  },
  title: {
    paddingTop: "8px",
    fontSize: "18px !important",
    letterSpacing: "1.5px !important",
    fontFamily: "Inter !important",
    fontWeight: "bold !important",
  },
  value: {
    paddingTop: "8px",
    fontSize: "18px !important",
    letterSpacing: "1.5px !important",
    fontFamily: "Inter !important",
    textTransform: "capitalize",
    minHeight: "38px",
  },
  noDataState: {
    padding: "8px",
    fontSize: "16px !important",
    letterSpacing: "1.5px !important",
    fontFamily: "Inter !important",
    textTransform: "capitalize",
    minHeight: "38px",
    textAlign: "left",
  },
  appointments: {
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  accordion: {
    marginTop: "20px",
    padding: "21px 20px 21px 21px",
    borderRadius: "10px",
    border: "1px solid rgba(112, 112, 112, 0.4)",
    backgroundColor: "white",
  },
  accordionDischargeSummary: {
    marginTop: "20px",
    padding: "21px 20px 21px 21px",
    borderRadius: "10px",
    border: "1px solid rgba(112, 112, 112, 0.4)",
    backgroundColor: "#AFC4FF",
    boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)"
  },
  accordionHeader: {
    backgroundColor: "white",
  },
  accordionHeaderSpacing: {
    justifyContent: "space-between",
    alignItems: "center",
  },
  accordionContent: {
    backgroundColor: "white",
    border: "1px solid rgba(112, 112, 112, 0.4)",
  },
  accordionContentDischargeSummary: {
    backgroundColor: "white",
    border: "1px solid rgba(112, 112, 112, 0.4)",
    padding: "0 15px"
  },
  appContentTitle: {
    color: "#5D5E76 !important",
    fontSize: "18px",
    letterSpacing: "1.35px",
    fontWeight: "bold",
  },
  appContentTitleDischargeSummary: {
    fontSize: "18px",
    letterSpacing: "1.35px",
    fontWeight: "bold",
    backgroundColor: "#AFC4FF",
    height: "100%",
  },
  appContentValue: {
    fontFamily: "Inter !important",
    fontWeight: "bold",
    fontSize: "17px",
    letterSpacing: "0.85px",
    color: "#000000",
  },
  accRightSection: {
    display: "flex",
    justifyContent: "end",
    height: "100%",
    alignItems: "center",
  },
  accRightSectionDocuments: {
    display: "flex",
    justifyContent: "end",
    height: "100%",
    alignItems: "center",
    backgroundColor: "#AFC4FF",
  },
  dataContent: {
    padding: "28px 30px 28px 0px",
  },
  dividerLine: {
    background: "#989898",
    width: "1px",
    minHeight: "111px",
    position: "absolute",
    left: "35px",
  },
  dividerSection: {
    paddingTop: "28px",
    position: "relative",
    width: "70px",
  },
  accordionEachRow: {},
  accordionRowContent: {
    padding: "21px 20px 21px 21px",
    marginTop: "20px",
    cursor: "pointer"
  },
  btmBorder: {
    borderBottom: "1px solid rgba(185, 200, 233, 0.7)",
  },
  top50: {
    top: "50px",
    minHeight: "100px !important",
  },
  titleSection: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "18px",
  },
  pl10: {
    paddingLeft: "10px",
  },
  pl30: {
    paddingLeft: "30px",
  },
  pl30DischargeSummary: {
    paddingLeft: "30px",
    backgroundColor: "#AFC4FF",
  },
  pt14: {
    paddingTop: "14px",
  },
  pt16: {
    paddingTop: "16px",
  },
  titleName: {
    fontSize: "24px",
    letterSpacing: "2.1px",
    fontFamily: "Inter !important",
    fontWeight: "bold",
  },
  docsContainer: {
    width: "60%",
    height: "fit-content",
    maxHeight: "600px",
    marginTop: "-20px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  fileList: {
    height: "fit-content",
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: "#F1F4FB 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 12px #5679C94D",
    border: "1px solid #5679C9",
    borderRadius: "10px",
    opacity: "1",
    justifyContent: "space-around",
    padding: "5px",
    marginTop: "20px",
    fontWeight: "600",
    letterSpacing: "1.5px",
    lineHeight: "20px",
    fontSize: "20px",
    color: "#000",
  },
  docIcon: {
    width: "50px",
    height: "30px"
  },
  fileName: {
    paddingRight: "10px",
    width: "80%",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  downloadIcon: {
    height: "35px"
  },
  titleNameVisitSummary: {
    fontSize: "16px",
    letterSpacing: "2.1px",
    fontFamily: "Inter !important",
    fontWeight: "bold",
    minWidth: "200px"
  },
  appContentValueSelection: {
    fontFamily: "Inter !important",
    fontWeight: "bold",
    fontSize: "17px",
    letterSpacing: "0.85px",
    color: "#000000",
    cursor: "pointer"
  },
}))
